module.exports = __webpack_public_path__ + "img/bgLoading.408f3205.png";